<script lang="ts" setup>
	import type { BatchUploadSteps } from '~/components/Uploads/batch.vue'
	import useEmployeesApi from '~/services/apis/employeesApi'

	const downloadingTemplate = shallowRef(false)
	const file = ref<null | File>(null)
	const { downloadEmployeesTemplate } = useEmployeesApi()
	const { readFile, downloadFileResource } = useFileExplorer()
	const { uploadProgress, error, pending } = useStreamReader()
	const modelValue = defineModel<FormData | null>('file')
	const emits = defineEmits<{
		(event: 'change', payload: FormData): void
	}>()
	const guide = reactive<BatchUploadSteps>({
		'Start Here': {
			key: 'start',
			desc: 'Download the CSV/ XLS file template below'
		},
		'Fill Details': {
			key: 'details',
			desc: 'Fill in the CSV/ XLS file you just downloaded with information of staff you want to deactivate from your dashboard. Key contents are: <span class="text-gray-600 font-medium">First name,Last name,Email address, Phone number</span> of staff to be removed. You can use <a href="https://docs.google.com/spreadsheets" target="_blank" class="text-blue-500 font-medium">Google sheet</a> to edit the template or save it to your desktop or any folder on your PC and edit with excel software. See sample below:'
		},
		'Upload saved file ': {
			key: 'upload',
			desc: 'Upload or drag & drop the saved CSV/ XLS file you just filled on your PC.'
		}
	})

	const sendFiles = () => {
		if (!file.value) {
			return useNotification().alert({
				message: 'Please provide a valid xls file',
				status: 400
			})
		}
		try {
			const formData = new FormData()
			formData.append('file', file.value)
			modelValue.value = formData
			emits('change', formData)
		} catch (e) {
			console.error(e)
		}
	}
	const downLoadFile = async () => {
		try {
			downloadingTemplate.value = true
			const result = await downloadEmployeesTemplate()
			if (result.value) {
				readFile(result.value, 'readAsDataURL', file => {
					const fileTarget = file?.target as FileReader
					if (fileTarget.result) {
						downloadFileResource(fileTarget.result as string, 'employees-template.xlsx')
					}
				})
			}
		} catch (e) {
			console.error(e)
		} finally {
			downloadingTemplate.value = false
		}
	}
</script>

<template>
	<div class="mx-auto max-w-[700px]">
		<uploads-progress v-if="pending && !error" :file="file" :progress="uploadProgress" />
		<uploads-batch
			v-else
			v-model:file="file"
			:downloading="downloadingTemplate"
			:step-guide="guide"
			preview-img-src="/images/png/employee-template.png"
			@download="downLoadFile"
			@change="sendFiles"
		/>
	</div>
</template>
